// extracted by mini-css-extract-plugin
export default {"carousel":"EeZmZu02WNhp6k_O1Bxq","extraimageContainerClass":"nvwI96x4ps8mKSRoccq7"};